var _style, _rect, _g, _path, _g2, _line, _line2, _line3, _line4, _polyline, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _g6, _g7, _g8, _polyline2, _polyline3, _polyline4, _g9, _g10, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 690 429",
    style: {
      enableBackground: "new 0 0 690 429"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EDEEEF;}\r\n\t.st1{fill:none;stroke:#3E3E3E;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st2{fill:#2D2E2D;}\r\n\t.st3{fill:#FFFFFF;stroke:##55A345;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st4{fill:#262F3E;}\r\n\t.st5{fill:#F8991D;}\r\n\t.st6{fill:##55A345;stroke:##55A345;stroke-width:12;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st7{fill:none;stroke:#686969;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:7;}\r\n\t.st8{fill:none;stroke:#F26B3A;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#55A345;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#5A5A5A;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill:#F26B39;}\r\n\t.st12{fill:#285AA6;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:#FFFFFF;}\r\n\t.st15{fill:#2E3387;}\r\n\t.st16{opacity:0.49;enable-background:new    ;}\r\n\t.st17{fill:#BDDAF2;}\r\n\t.st18{opacity:0.49;fill:#BDDAF2;enable-background:new    ;}\r\n\t.st19{fill:#2859A6;}\r\n\t.st20{fill:#97C8EA;}\r\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_40_",
    x: 197,
    y: 173.1,
    className: "st0",
    width: 329.4,
    height: 219.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st1",
    d: "M529.1,395.2H201c-4.1,0-7.4-3.3-7.4-7.4V191.1c0-10.1,8.3-18.3,18.3-18.3h306.2 c6,0,10.9,4.9,10.9,10.9L529.1,395.2L529.1,395.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st2",
    d: "M173.7,402.1h377.6c4.8,0,8.4,4.5,7.2,9.2v0c-0.8,3.3-3.8,5.7-7.2,5.7H173.7c-3.2,0-6-2-7-5 l0,0C165,407.2,168.6,402.1,173.7,402.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st3",
    d: "M392.2,352.8h61.1c1.5,0.3,3.1,0.4,4.7,0.4c14.5,0,26.3-12.2,26.3-27.2s-11.8-27.2-26.3-27.2 c-0.4,0-0.7,0-1.1,0c1.3-3.5,2-7.3,2-11.3c0-17.6-13.8-31.9-30.9-31.9c-1.9,0-3.7,0.2-5.4,0.5c-6.3-19.4-24-33.3-44.8-33.3 c-12.2,0-23.3,4.8-31.7,12.6c-5.5-2.8-11.8-4.4-18.4-4.4c-19.6,0-36,14-40.4,32.8c-0.7,0-1.5-0.1-2.2-0.1 c-23.8,0-43.1,19.9-43.1,44.5c0,24.6,19.3,44.5,43.1,44.5h37.3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st4",
    d: "M331.2,292.1c0,1.5,0.2,2.8,0.4,3.7c0.3,0.9,0.7,1.9,1.3,3c0.2,0.3,0.3,0.7,0.3,0.9 c0,0.4-0.2,0.8-0.8,1.2l-2.6,1.7c-0.4,0.2-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.2-1.2-0.6c-0.6-0.6-1.1-1.3-1.5-1.9 c-0.4-0.7-0.8-1.5-1.3-2.4c-3.2,3.8-7.3,5.7-12.2,5.7c-3.5,0-6.3-1-8.3-3c-2-2-3.1-4.7-3.1-8c0-3.5,1.2-6.4,3.8-8.6 c2.5-2.2,5.9-3.2,10.2-3.2c1.4,0,2.9,0.1,4.4,0.3c1.5,0.2,3.1,0.5,4.8,0.9v-3c0-3.2-0.7-5.3-1.9-6.6c-1.3-1.3-3.6-1.9-6.8-1.9 c-1.4,0-2.9,0.2-4.5,0.5c-1.5,0.4-3,0.8-4.5,1.4c-0.7,0.3-1.2,0.4-1.4,0.5c-0.3,0.1-0.5,0.1-0.7,0.1c-0.6,0-0.9-0.4-0.9-1.3v-2 c0-0.7,0.1-1.2,0.3-1.4c0.2-0.3,0.6-0.6,1.2-0.9c1.4-0.7,3.2-1.4,5.2-1.9c2-0.5,4.2-0.8,6.5-0.8c5,0,8.6,1.1,10.9,3.4 c2.3,2.2,3.4,5.6,3.4,10.2L331.2,292.1L331.2,292.1z M314.3,298.4c1.4,0,2.8-0.2,4.3-0.7s2.8-1.4,4-2.7c0.6-0.8,1.1-1.6,1.4-2.6 s0.4-2.2,0.4-3.6V287c-1.2-0.3-2.5-0.5-3.8-0.7c-1.3-0.2-2.6-0.2-3.9-0.2c-2.8,0-4.8,0.5-6.2,1.7c-1.4,1.1-2,2.7-2,4.8 c0,1.9,0.5,3.4,1.5,4.4C311,297.9,312.4,298.4,314.3,298.4z M347.6,302.9c-0.7,0-1.2-0.1-1.6-0.4c-0.3-0.2-0.6-0.8-0.9-1.6 l-9.8-32.1c-0.2-0.8-0.4-1.4-0.4-1.7c0-0.7,0.3-1,1-1h4.1c0.8,0,1.3,0.1,1.6,0.4c0.3,0.2,0.6,0.8,0.8,1.6l7,27.5l6.5-27.5 c0.2-0.8,0.4-1.4,0.8-1.6c0.3-0.2,0.9-0.4,1.7-0.4h3.3c0.8,0,1.3,0.1,1.7,0.4c0.3,0.2,0.6,0.8,0.8,1.6l6.6,27.8l7.2-27.8 c0.2-0.8,0.5-1.4,0.8-1.6c0.3-0.2,0.9-0.4,1.6-0.4h3.9c0.7,0,1,0.3,1,1c0,0.2,0,0.4-0.1,0.7c0,0.2-0.1,0.6-0.3,1l-10,32.1 c-0.2,0.8-0.5,1.4-0.9,1.6c-0.3,0.2-0.9,0.4-1.6,0.4H369c-0.8,0-1.3-0.1-1.7-0.4c-0.3-0.3-0.6-0.8-0.8-1.7l-6.5-26.8l-6.4,26.7 c-0.2,0.8-0.4,1.4-0.8,1.7c-0.3,0.3-0.9,0.4-1.7,0.4L347.6,302.9L347.6,302.9z M401,304c-2.2,0-4.3-0.2-6.4-0.7s-3.7-1-4.8-1.7 c-0.7-0.4-1.1-0.8-1.3-1.2c-0.2-0.4-0.2-0.8-0.2-1.2v-2.1c0-0.9,0.3-1.3,0.9-1.3c0.2,0,0.5,0,0.7,0.1c0.2,0.1,0.6,0.2,1,0.4 c1.4,0.6,2.9,1.1,4.6,1.4c1.7,0.3,3.3,0.5,5,0.5c2.6,0,4.7-0.4,6.1-1.4c1.4-0.9,2.2-2.2,2.2-4c0-1.2-0.4-2.1-1.1-2.9 s-2.2-1.5-4.2-2.2l-6-1.9c-3-0.9-5.3-2.4-6.6-4.2c-1.4-1.8-2.1-3.9-2.1-6c0-1.7,0.4-3.3,1.1-4.6s1.7-2.5,3-3.4 c1.2-0.9,2.7-1.7,4.3-2.2c1.7-0.5,3.4-0.7,5.2-0.7c0.9,0,1.9,0,2.8,0.2c0.9,0.1,1.8,0.3,2.7,0.4c0.8,0.2,1.6,0.4,2.4,0.7 s1.3,0.5,1.7,0.7c0.6,0.3,1,0.7,1.2,1c0.2,0.3,0.4,0.8,0.4,1.4v1.9c0,0.9-0.3,1.3-0.9,1.3c-0.3,0-0.9-0.2-1.6-0.5 c-2.4-1.1-5-1.6-8-1.6c-2.4,0-4.2,0.4-5.5,1.2s-1.9,2-1.9,3.7c0,1.2,0.4,2.2,1.2,2.9c0.8,0.8,2.4,1.6,4.6,2.3l5.9,1.9 c3,0.9,5.1,2.3,6.4,4s1.9,3.7,1.9,5.8c0,1.8-0.4,3.4-1.1,4.8c-0.7,1.4-1.7,2.7-3,3.7c-1.3,1-2.8,1.8-4.6,2.3 C405,303.8,403.1,304,401,304z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st5",
    d: "M408.8,324.2c-13.7,10.1-33.5,15.4-50.5,15.4c-23.9,0-45.4-8.8-61.7-23.5 c-1.3-1.2-0.1-2.7,1.4-1.8c17.6,10.2,39.3,16.4,61.8,16.4c15.1,0,31.8-3.2,47.1-9.6C409.1,320,411.1,322.6,408.8,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st5",
    d: "M414.5,317.7c-1.7-2.2-11.5-1.1-16-0.5c-1.3,0.2-1.5-1-0.3-1.9c7.8-5.5,20.6-3.9,22.1-2.1 c1.5,1.9-0.4,14.7-7.7,20.8c-1.1,0.9-2.2,0.4-1.7-0.8C412.5,329.2,416.3,319.9,414.5,317.7z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_21_",
    className: "st6",
    x1: 322.4,
    y1: 352.7,
    x2: 392.1,
    y2: 352.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_72_",
    className: "st7",
    x1: 83.7,
    y1: 256.2,
    x2: 186.7,
    y2: 256.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_73_",
    className: "st7",
    x1: 82.2,
    y1: 295.9,
    x2: 82.2,
    y2: 256.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_76_",
    className: "st7",
    x1: 132.2,
    y1: 254.9,
    x2: 132.2,
    y2: 132
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_55_",
    className: "st7",
    points: "535.6,211.5 589.4,211.5 589.4,263.7 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st8",
    d: "M33.1,238.2h-2.6v-8.1h2.6c1.6,0,3.1-1,3.7-2.5v-0.1c0.6-1.5,0.3-3.2-0.9-4.4l-1.8-1.8l5.7-5.7 l1.8,1.8c1.2,1.2,2.9,1.5,4.4,0.9h0.1c1.5-0.6,2.5-2.1,2.5-3.7V212h8.1v2.6c0,1.6,1,3.1,2.5,3.7h0.1c1.5,0.6,3.2,0.3,4.4-0.9 l1.8-1.8l5.7,5.7l-1.8,1.8c-1.2,1.2-1.5,2.9-0.9,4.4v0.1c0.6,1.5,2.1,2.5,3.7,2.5h2.6v8.1h-2.6c-1.6,0-3.1,1-3.7,2.5v0.1 c-0.6,1.5-0.3,3.2,0.9,4.4l1.8,1.8l-5.7,5.7l-1.8-1.8c-1.2-1.2-2.9-1.5-4.4-0.9h-0.1c-1.5,0.6-2.5,2.1-2.5,3.7v2.6h-8.1v-2.6 c0-1.6-1-3.1-2.5-3.7H46c-1.5-0.6-3.2-0.3-4.4,0.9l-1.8,1.8l-5.7-5.7l1.8-1.8c1.2-1.2,1.5-2.9,0.9-4.4v-0.1 C36.2,239.2,34.7,238.2,33.1,238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st8",
    d: "M59.7,234.2c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.2-0.7,1.7c-0.6,1.1-1.5,2-2.6,2.6 c-0.5,0.3-1.1,0.5-1.7,0.7s-1.2,0.2-1.8,0.2s-1.2-0.1-1.8-0.2c-0.6-0.2-1.2-0.4-1.7-0.7c-1.1-0.6-2-1.5-2.6-2.6 c-0.3-0.5-0.5-1.1-0.7-1.7s-0.2-1.2-0.2-1.8c0-0.6,0.1-1.2,0.2-1.8c0.2-0.6,0.4-1.2,0.7-1.7c0.6-1.1,1.5-2,2.6-2.6 c0.5-0.3,1.1-0.5,1.7-0.7s1.2-0.2,1.8-0.2s1.2,0.1,1.8,0.2c0.6,0.2,1.2,0.4,1.7,0.7c1.1,0.6,2,1.5,2.6,2.6c0.3,0.5,0.5,1.1,0.7,1.7 C59.6,232.9,59.7,233.5,59.7,234.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st9",
    d: "M625.1,215.4h-2.6v-8.1h2.6c1.6,0,3.1-1,3.7-2.5v-0.1c0.6-1.5,0.3-3.2-0.9-4.4l-1.8-1.8 l5.7-5.7l1.8,1.8c1.2,1.2,2.9,1.5,4.4,0.9h0.1c1.5-0.6,2.5-2.1,2.5-3.7v-2.6h8.1v2.6c0,1.6,1,3.1,2.5,3.7h0.1 c1.5,0.6,3.2,0.3,4.4-0.9l1.8-1.8l5.7,5.7l-1.8,1.8c-1.2,1.2-1.5,2.9-0.9,4.4v0.1c0.6,1.5,2.1,2.5,3.7,2.5h2.6v8.1h-2.6 c-1.6,0-3.1,1-3.7,2.5v0.1c-0.6,1.5-0.3,3.2,0.9,4.4l1.8,1.8l-5.7,5.7l-1.8-1.8c-1.2-1.2-2.9-1.5-4.4-0.9h-0.1 c-1.5,0.6-2.5,2.1-2.5,3.7v2.6h-8.1v-2.6c0-1.6-1-3.1-2.5-3.7H638c-1.5-0.6-3.2-0.3-4.4,0.9l-1.8,1.8l-5.7-5.7l1.8-1.8 c1.2-1.2,1.5-2.9,0.9-4.4v-0.1C628.2,216.4,626.7,215.4,625.1,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st9",
    d: "M651.7,211.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.2-0.7,1.7c-0.6,1.1-1.5,2-2.6,2.6 c-0.5,0.3-1.1,0.5-1.7,0.7c-0.6,0.2-1.2,0.2-1.8,0.2c-0.6,0-1.2-0.1-1.8-0.2c-0.6-0.2-1.2-0.4-1.7-0.7c-1.1-0.6-2-1.5-2.6-2.6 c-0.3-0.5-0.5-1.1-0.7-1.7s-0.2-1.2-0.2-1.8c0-0.6,0.1-1.2,0.2-1.8c0.2-0.6,0.4-1.2,0.7-1.7c0.6-1.1,1.5-2,2.6-2.6 c0.5-0.3,1.1-0.5,1.7-0.7s1.2-0.2,1.8-0.2c0.6,0,1.2,0.1,1.8,0.2c0.6,0.2,1.2,0.4,1.7,0.7c1.1,0.6,2,1.5,2.6,2.6 c0.3,0.5,0.5,1.1,0.7,1.7C651.6,210.1,651.7,210.7,651.7,211.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st10",
    d: "M644.1,267.9H642v-6.8h2.2c1.3,0,2.6-0.8,3.1-2.1V259c0.5-1.3,0.3-2.7-0.8-3.7l-1.5-1.5 l4.8-4.8l1.5,1.5c1,1,2.4,1.3,3.7,0.8h0.1c1.3-0.5,2.1-1.8,2.1-3.1v-2.2h6.8v2.2c0,1.3,0.8,2.6,2.1,3.1h0.1 c1.3,0.5,2.7,0.3,3.7-0.8l1.5-1.5l4.8,4.8l-1.5,1.5c-1,1-1.3,2.4-0.8,3.7v0.1c0.5,1.3,1.8,2.1,3.1,2.1h2.2v6.8h-2.2 c-1.3,0-2.6,0.8-3.1,2.1v0.1c-0.5,1.3-0.3,2.7,0.8,3.7l1.5,1.5l-4.8,4.8l-1.5-1.5c-1-1-2.4-1.3-3.7-0.8h-0.1 c-1.3,0.5-2.1,1.8-2.1,3.1v2.2H657v-2.2c0-1.3-0.8-2.6-2.1-3.1h-0.1c-1.3-0.5-2.7-0.3-3.7,0.8l-1.5,1.5l-4.8-4.8l1.5-1.5 c1-1,1.3-2.4,0.8-3.7V270C646.7,268.8,645.5,267.9,644.1,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    className: "st10",
    d: "M666.3,264.6c0,0.5-0.1,1-0.2,1.5c-0.2,0.5-0.3,1-0.6,1.4c-0.5,0.9-1.3,1.7-2.2,2.2 c-0.4,0.3-0.9,0.4-1.4,0.6c-0.5,0.2-1,0.2-1.5,0.2c-0.5,0-1-0.1-1.5-0.2c-0.5-0.2-1-0.3-1.4-0.6c-0.9-0.5-1.7-1.3-2.2-2.2 c-0.3-0.4-0.4-0.9-0.6-1.4c-0.2-0.5-0.2-1-0.2-1.5s0.1-1,0.2-1.5c0.2-0.5,0.3-1,0.6-1.4c0.5-0.9,1.3-1.7,2.2-2.2 c0.4-0.3,0.9-0.4,1.4-0.6c0.5-0.2,1-0.2,1.5-0.2c0.5,0,1,0.1,1.5,0.2c0.5,0.2,1,0.3,1.4,0.6c0.9,0.5,1.7,1.3,2.2,2.2 c0.3,0.4,0.4,0.9,0.6,1.4C666.2,263.5,666.3,264,666.3,264.6z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st11",
    d: "M167.2,98.6c0.7-1.4,1-3.1,1-4.8c0-7.4-6.8-13.4-15-13.4c-3.1,0-6,0.8-8.3,2.2 c-4.3-6.6-12.4-11.2-21.6-11.2c-13.8,0-25,10-25,22.3c0,0.4,0,0.8,0,1.2c-8.7,2.7-15,10.2-15,19c0,11.1,10,20.1,22.5,20.1h57.6 c11.1,0,20.1-7.9,20.1-17.8C183.1,107.4,176.3,100.3,167.2,98.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st12",
    d: "M293.2,34.1c0.7-1.4,1-3.1,1-4.8c0-7.4-6.8-13.4-15-13.4c-3.1,0-6,0.8-8.3,2.2 c-4.3-6.6-12.4-11.2-21.6-11.2c-13.8,0-25,10-25,22.3c0,0.4,0,0.8,0,1.2c-8.7,2.7-15,10.2-15,19c0,11.1,10,20.1,22.5,20.1h57.6 c11.1,0,20.1-7.9,20.1-17.8C309.1,42.9,302.3,35.8,293.2,34.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st12",
    d: "M650.3,67.3c0.7-1.4,1-3.1,1-4.8c0-7.4-6.8-13.4-15-13.4c-3.1,0-6,0.8-8.3,2.2 c-4.3-6.6-12.4-11.2-21.6-11.2c-13.8,0-25,10-25,22.3c0,0.4,0,0.8,0,1.2c-8.7,2.7-15,10.2-15,19c0,11.1,10,20.1,22.5,20.1h57.6 c11.1,0,20.1-7.9,20.1-17.8C666.2,76.1,659.4,69,650.3,67.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st11",
    d: "M480.2,88.7c0.7-1.4,1-3.1,1-4.8c0-7.4-6.8-13.4-15-13.4c-3.1,0-6,0.8-8.3,2.2 c-4.3-6.6-12.4-11.2-21.6-11.2c-13.8,0-25,10-25,22.3c0,0.4,0,0.8,0,1.2c-8.7,2.7-15,10.2-15,19c0,11.1,10,20.1,22.5,20.1h57.6 c11.1,0,20.1-7.9,20.1-17.8C496.1,97.5,489.3,90.4,480.2,88.7z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "globe_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_81_",
    className: "st13",
    cx: 132.1,
    cy: 108.5,
    r: 17.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st13",
    d: "M117.7,118.2c3.1-1.9,25.6-1.9,28.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st13",
    d: "M117.1,99.9c3,2,27.1,2,30.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st13",
    d: "M140.4,108.5c0,9.6-6,17.3-8.3,17.3s-8.3-7.8-8.3-17.3s6-17.3,8.3-17.3S140.4,99,140.4,108.5z "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_77_",
    className: "st13",
    x1: 114.8,
    y1: 109.3,
    x2: 149.4,
    y2: 109.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iphone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st14",
    d: "M532,415.4c-3,0-5.4-2.4-5.4-5.4V271.6c0-3,2.4-5.4,5.4-5.4h67.3c3,0,5.4,2.4,5.4,5.4v138.3 c0,3-2.4,5.4-5.4,5.4L532,415.4L532,415.4L532,415.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st15",
    d: "M599.3,268.5c1.8,0,3.2,1.4,3.2,3.2V410c0,1.8-1.4,3.2-3.2,3.2H532c-1.8,0-3.2-1.4-3.2-3.2 V271.6c0-1.8,1.4-3.2,3.2-3.2L599.3,268.5 M599.3,264.1H532c-4.2,0-7.6,3.4-7.6,7.6V410c0,4.2,3.4,7.6,7.6,7.6h67.3 c4.2,0,7.6-3.4,7.6-7.6V271.6C606.9,267.5,603.5,264.1,599.3,264.1L599.3,264.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st15",
    d: "M603.2,285.5H528c-1,0-1.9-0.8-1.9-1.9v-14.4c0-1,0.8-1.9,1.9-1.9h75.2c1,0,1.9,0.8,1.9,1.9 v14.4C605.1,284.6,604.3,285.5,603.2,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st15",
    d: "M603.2,414.4H528c-1,0-1.9-0.8-1.9-1.9v-20.3c0-1,0.8-1.9,1.9-1.9h75.2c1,0,1.9,0.8,1.9,1.9 v20.3C605.1,413.5,604.3,414.4,603.2,414.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st14",
    d: "M572.1,275.7h-14.8c-0.8,0-1.5-0.7-1.5-1.5v-0.6c0-0.8,0.7-1.5,1.5-1.5h14.8 c0.8,0,1.5,0.7,1.5,1.5v0.6C573.7,275,573,275.7,572.1,275.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_46_",
    className: "st14",
    cx: 565.8,
    cy: 403.2,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines_1_",
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st17",
    d: "M595.8,298.3h-60c-0.4,0-0.6-0.5-0.6-1.2v-6c0-0.6,0.3-1.2,0.6-1.2h60c0.4,0,0.6,0.5,0.6,1.2 v6C596.4,297.9,596.2,298.3,595.8,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st17",
    d: "M595.8,312.6h-60c-0.4,0-0.6-0.5-0.6-1.2v-6c0-0.6,0.3-1.2,0.6-1.2h60c0.4,0,0.6,0.5,0.6,1.2 v6C596.4,312.1,596.2,312.6,595.8,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st17",
    d: "M563.9,327.4h-28.2c-0.4,0-0.6-0.5-0.6-1.2v-6c0-0.6,0.3-1.2,0.6-1.2h28.2 c0.4,0,0.6,0.5,0.6,1.2v6C564.5,326.9,564.2,327.4,563.9,327.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st18",
    d: "M595.2,384h-59.4c-0.6,0-1.2-0.4-1.2-0.7v-49.1c0-0.4,0.5-0.7,1.2-0.7h59.4 c0.6,0,1.2,0.4,1.2,0.7v49.1C596.4,383.7,595.8,384,595.2,384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st18",
    d: "M87.5,365.2H28.1c-0.6,0-1.2-0.4-1.2-0.7v-49.1c0-0.4,0.5-0.7,1.2-0.7h59.4 c0.6,0,1.2,0.4,1.2,0.7v49.1C88.7,364.9,88.1,365.2,87.5,365.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg_1_",
    className: "st19",
    d: "M18,414.4h127.7c4.3,0,7.9-3.5,7.9-7.9V304.3c0-4.3-3.5-7.9-7.9-7.9H18.3c-4.3,0-7.9,3.5-7.9,7.9 v102.2C10.2,410.9,13.7,414.4,18,414.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_71_",
    x: 18.4,
    y: 316,
    className: "st14",
    width: 125.7,
    height: 89.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_70_",
    className: "st14",
    cx: 141.4,
    cy: 306.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_69_",
    className: "st17",
    cx: 132.1,
    cy: 306.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st14",
    d: "M22.3,309.4h59.3c1.8,0,3.2-1.4,3.2-3.2l0,0c0-1.8-1.4-3.2-3.2-3.2H22.3 c-1.8,0-3.2,1.4-3.2,3.2l0,0C19.3,308,20.8,309.4,22.3,309.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_67_",
    className: "st14",
    cx: 122.9,
    cy: 306.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_62_",
    x: 28.5,
    y: 373.1,
    className: "st20",
    width: 103.6,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_61_",
    x: 28.5,
    y: 382.7,
    className: "st20",
    width: 103.6,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: 28.5,
    y: 392.3,
    className: "st20",
    width: 86.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_74_",
    x: 84,
    y: 343.7,
    className: "st20",
    width: 48.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_75_",
    x: 84.2,
    y: 334.6,
    className: "st20",
    width: 48.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_92_",
    x: 84.8,
    y: 325.8,
    className: "st20",
    width: 48.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_59_",
    x: 84,
    y: 352.3,
    className: "st20",
    width: 48.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_58_",
    x: 84,
    y: 363,
    className: "st20",
    width: 40,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st18",
    d: "M75.2,365.2h-46c-0.5,0-0.9-0.3-0.9-0.5v-38.2c0-0.3,0.4-0.5,0.9-0.5h46 c0.5,0,0.9,0.3,0.9,0.5v38.2C76.2,365,75.7,365.2,75.2,365.2z"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_10_",
    className: "st7",
    points: "258.7,69.5 258.7,117.5 319.4,117.5 319.4,165.6 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_7_",
    className: "st7",
    points: "319.4,143.6 446.7,143.6 446.7,124.1 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_11_",
    className: "st7",
    points: "562.8,211.5 562.8,164.1 617.4,164.1 617.4,125.9 617.4,102.7 "
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st13",
    d: "M244.9,55.1c0,1.4,0.6,2.8,1.8,3.9c2.3,2.4,6.5,3.9,11.3,3.9s9-1.6,11.3-3.9 c1.2-1.2,1.8-2.5,1.8-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st13",
    d: "M244.9,38.4c0,1.4,0.6,2.8,1.8,3.9c2.3,2.4,6.5,3.9,11.3,3.9s9-1.6,11.3-3.9 c1.2-1.2,1.8-2.5,1.8-3.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_17_",
    className: "st13",
    cx: 258,
    cy: 30.6,
    rx: 13.1,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st13",
    d: "M244.9,47.2c0,1.4,0.6,2.8,1.8,3.9c2.3,2.4,6.5,3.9,11.3,3.9s9-1.6,11.3-3.9 c1.2-1.2,1.8-2.5,1.8-3.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_14_",
    className: "st13",
    points: "270.9,32.1 270.9,39.9 270.9,47.7 270.9,55.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_13_",
    className: "st13",
    points: "244.9,31.6 244.9,39.4 244.9,47.2 244.9,55.1  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    className: "st21",
    d: "M445.4,78.6l-15.8,7v10.5c0,9.8,6.7,18.9,15.8,21.1c9.1-2.2,15.8-11.3,15.8-21.1V85.6 L445.4,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st21",
    d: "M441.9,101.4l-3.4-3.4c-0.5-0.5-1.2-0.5-1.7,0l0,0c-0.5,0.5-0.5,1.2,0,1.7l5.1,5.1 c0.5,0.5,1.2,0.5,1.7,0L456.5,92c0.5-0.5,0.5-1.2,0-1.7l0,0c-0.5-0.5-1.2-0.5-1.7,0l-11.2,11.2 C443.1,101.9,442.3,101.9,441.9,101.4z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st14",
    d: "M611.1,76.9h-11.2c-1.3,0-2.3-1-2.3-2.3V63.4c0-1.3,1-2.3,2.3-2.3h11.2c1.3,0,2.3,1,2.3,2.3 v11.2C613.4,75.9,612.4,76.9,611.1,76.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st14",
    d: "M611.6,96.4h-11.2c-1.3,0-2.3-1-2.3-2.3V82.9c0-1.3,1-2.3,2.3-2.3h11.2c1.3,0,2.3,1,2.3,2.3 v11.2C613.9,95.4,612.9,96.4,611.6,96.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st14",
    d: "M631,96.4h-11.2c-1.3,0-2.3-1-2.3-2.3V82.9c0-1.3,1-2.3,2.3-2.3H631c1.3,0,2.3,1,2.3,2.3v11.2 C633.3,95.4,632.2,96.4,631,96.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st14",
    d: "M627.3,75.7l-10-5.1c-1.1-0.6-1.6-2-1-3.1l5.1-10c0.6-1.1,2-1.6,3.1-1l10,5.1 c1.1,0.6,1.6,2,1,3.1l-5.1,10C629.8,75.8,628.4,76.3,627.3,75.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsDevelopment);
export default __webpack_public_path__ + "static/media/aws-development.dd0813e4b07c04abc1c9c84948303f12.svg";
export { ForwardRef as ReactComponent };